export const LOGIN = "LOGIN";
export const LOGIN_ERROR = "LOGIN_ERROR";
export const DECODER = "DECODER";
export const PROFISSAS = "PROFISSAS";
export const SCHEDULES = "SCHEDULES";
export const FEEDBACKS = "FEEDBACKS";
export const SERVICE_RESQUEST = "SERVICE_RESQUEST";
export const CLEAN_TOKEN = "CLEAN_TOKEN";
export const INFOS_PROFISSA = "INFOS_PROFISSA";
export const USERS = "USERS";
export const CHANGE_USER_DATA = "CHANGE_USER_DATA";
